export default __webpack_public_path__ + "static/ROLVEDON-Distribution-Flashcard-442c7e5fd28f962533f7021737e59a7b.png";